// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Il","button":"i_Im","icon":"i_In","collapsed-icon":"i_Io","expanded-icon":"i_Ip"};